<cc-user-header
  title="Sitemate Free Users"
  [learnMoreLink]="
    'https://intercom.help/dashpivot/en/articles/3901878-setting-up-a-contactless-sign-on-process'
  "
>
</cc-user-header>
<div class="sm-flex sm-flex-col sm-space-y-4">
  <div id="sitemate-app-description" class="sm-text-sm sm-font-normal sm-leading-4">
    <p>The Sitemate app is free for anyone to download and use on their phone or tablet, and setup a digital ID.</p>
    <br />
    <p>You can streamline processes that involve collecting a large number of signatures from your workforce, by
    using the ‘Scan Sitemate ID’ field in your Dashpivot templates. This field allows you to scan the digital
    ID of anyone that has a Sitemate app profile setup, and auto-populate their name, company and signature
    onto a form.</p>
    <br />
    <p>You can also setup Sitemate Links to share with Sitemate app users, allowing them to submit single forms
    into Dashpivot for free. The Sitemate user will retain a view-only record of the form they submitted for
    reference.</p>
    <br />
    <p>Sitemate users will retain a log of their activity, with view-only access to any forms they sign or submit
    using the app.</p>
  </div>

  <div class="sm-flex sm-flex-row sm-justify-between sm-pb-legacy-9.6">
    <div class="sm-flex sm-flex-row">
      <div class="sm-flex-1">
        <img
          id="sitemate-app-demo"
          class="sitemate-app-demo sm-h-full sm-w-full sm-self-start sm-rounded"
          src="./assets/images/user/sitemate-users/sitemate-scan-demo.png"
          alt="scanning a sitemate id through the app from an iPad"
        />
      </div>
      <div class="sm-flex sm-flex-1 sm-flex-col sm-items-center sm-justify-center">
        <img
          class="sitemate-id-mockup"
          src="./assets/images/user/sitemate-users/sitemate-id-mockup.svg"
          alt="sitemate-id-mockup"
        />
        <div class="app-download-buttons sm-flex sm-flex-row">
          <a
            id="sitemate-app-store-download"
            href="https://apps.apple.com/au/app/sitemate/id1509197957"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              class="mr-3"
              src="./assets/images/user/sitemate-users/app-store-download.svg"
              alt="download sitemate app on app store"
            />
          </a>
          <a
            id="sitemate-play-store-download"
            href="https://play.google.com/store/apps/details?id=com.sitemate.id2&hl=en_AU&gl=US"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="./assets/images/user/sitemate-users/play-store-download.svg"
              alt="download sitemate app on play store"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
